module.exports = __webpack_public_path__ + "static/icon001163974322351743cbeb384fc7cd5ce18.png";